<div class="business-overdraft-rate-card-component">

  <!-- ZEN-818 follow-up: BL/OD rate cards replace the base-rate + uplift model with a 3-tier model. -->
  <div class="mat-h3 rate-card-section-title">Tier Rates</div>
  <div class="row">
    <div class="col-lg-4 col-md-12">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Tier 1 Rate</mat-label>
        <input matInput [inputMask]="createTwoDecimalInputMask" type="text" [formControl]="formControlTier1Rate" required>
        <span class="mdi mdi-percent" matSuffix></span>
        <mat-hint>TIB ≥ 60m · EF Director ≥ 700 · Property Backed</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-lg-4 col-md-12">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Tier 2 Rate</mat-label>
        <input matInput [inputMask]="createTwoDecimalInputMask" type="text" [formControl]="formControlTier2Rate" required>
        <span class="mdi mdi-percent" matSuffix></span>
        <mat-hint>TIB ≥ 36m · EF Director ≥ 550 · Property Backed</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-lg-4 col-md-12">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Tier 3 Rate</mat-label>
        <input matInput [inputMask]="createTwoDecimalInputMask" type="text" [formControl]="formControlTier3Rate" required>
        <span class="mdi mdi-percent" matSuffix></span>
        <mat-hint>TIB ≥ 36m · EF Director ≥ 550 · Not Property Backed</mat-hint>
      </mat-form-field>
    </div>
  </div>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <div class="mat-h3 rate-card-section-title">Facility Fees</div>
  <div class="row">
    <div class="col-lg-3 col-md-12">
      <mat-form-field>
        <mat-label>Facility Fee</mat-label>
        <input matInput [inputMask]="createTwoDecimalInputMask" type="text" [formControl]="formControlFacilityFee" required>
        <span class="mdi mdi-percent" matSuffix></span>
        @for (errorKey of errorKeys(formControlFacilityFee); track errorKey) {
          <mat-error>
            @if (formControlFacilityFee.touched && formControlFacilityFee.hasError(errorKey)) {
              {{errorMessage(formControlFacilityFee, errorKey)}}
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-lg-3 col-md-12">
      <mat-form-field>
        <mat-label>RBA Rate (readonly)</mat-label>
        <input readonly matInput type="text" [formControl]="formControlRbaRate">
        <span class="mdi mdi-percent" matSuffix></span>
        @for (errorKey of errorKeys(formControlRbaRate); track errorKey) {
          <mat-error>
            @if (formControlRbaRate.touched && formControlRbaRate.hasError(errorKey)) {
              {{errorMessage(formControlRbaRate, errorKey)}}
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <min-max-rate title="Doc fee" [type]="'currency'" [formControl]="formControlDocFee"></min-max-rate>

</div>
